<!-- <p>assessment-popup works!</p> -->
<!-- <div class="popup-backdrop">
  <div class="popup-modal">
    <div class="popup-header">
      <h2>Manage Assessment</h2>
      <button class="close-btn" (click)="onCancel()">&times;</button>
    </div>
    <div class="popup-body">
      <p>Would you like to manage assessment for:</p>
      <h3>{{ skillName }}</h3>
    </div>
    <div class="popup-footer">
      <button class="btn cancel" (click)="onCancel()">Cancel</button>
      <button class="btn confirm" (click)="onConfirm()">Confirm</button>
    </div>
  </div>
</div> -->

<div class="popup-backdrop">
  <div class="popup-modal">
    <div class="popup-header">
      <h2>Add Assessment</h2>
      <button class="close-btn" (click)="onCancel()">×</button>
    </div>

    <div class="popup-body">
        <a-input type="text"  [control]="form.get('referenceId')" label="Assessment Id" placeholder="Paste Assessment Id.."  [isSubmitted]="isSubmitted"></a-input>

        <a-input type="text"  [control]="form.get('assessmentTool')" label="Assessment Tool" placeholder="Assessment Tool"></a-input>

      <p>Selected skill:</p>
      <h3>{{ skillName }}</h3>
    </div>
    <!-- <div class="popup-footer">
      <button class="btn cancel" (click)="onCancel()">Cancel</button>
      <button class="btn confirm" (click)="onConfirm()">Confirm</button>
    </div> -->
       <div class="hard-skills-tree__single-skill__btns">
      <div class="is-btn is-btn__outfill" (click)="onCancel()">Cancel</div>
      <div class="is-btn" (click)="onConfirm()">Save</div>
    </div>
  </div>
</div>
